/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Wire the mobile-only search-bar trigger to the autocomplete button.
 *
 * @type {Listener}
 */
export default {
    selector: '#mobile--search',
    connect(element) {
        const onClick = () => {
            const button = document.getElementById('autocomplete')?.querySelector('button')
            button?.click()
        }

        element.addEventListener('click', onClick)

        return () => element.removeEventListener('click', onClick)
    },
}
